const SanbiaoAKeyTender = resolve => {
    import(/* webpackChunkName: 'sanbiaoAKeyTender' */'../views/sanbiao/akeytender').then(sanbiaoAKeyTender => {
        resolve(sanbiaoAKeyTender)
    })
}
export default [
    {
        path: '/sanbiao/akeytender',
        name: 'sanbiaoAKeyTender',
        component: SanbiaoAKeyTender,
        meta: {
            title: '一键投标授权协议'
        }
    }
]
